<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container bottom-footer">
        <!-- Outer Row -->
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <LogoColor formatting="logo-center" width="280px"></LogoColor>
                <div class="card o-hidden border-0 shadow-lg">
                    <div class="card-body card-body-no-spaccing p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div class="p-5">
                                    <div class="text-center">
                                        <div class="alert alert-info">
                                            <p class="text-justify">Estamos felizes em ter você com a gente! 💙. Por
                                                gentileza, informe seu CPF ou CNPJ para redefinir a sua senha.</p>
                                        </div>
                                        <h6 class="text-gray-900 text-justify"></h6>
                                        <hr>
                                    </div>
                                    <form class="user" @submit="resetPassword">
                                        <div class="form-group">
                                            <label for="">Informe seu CPF / CNPJ</label>
                                            <input type="text" class="form-control form-control-user" id="document"
                                                aria-describedby="documentHelp" placeholder="xxx.xxx.xxx-xx"
                                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                v-model="authentication.document">
                                        </div>
                                        <button type="submit" :disabled='!isDisabled'
                                            class="btn btn-primary btn-user btn-block">
                                            <i class="fas fa-check"></i> Solicitar nova senha
                                        </button>

                                    </form>
                                    <hr>
                                    <router-link class="btn btn-link" to="login">Realizar autenticação</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import LogoColor from '../img/logo-color.vue';
import axios from 'axios';


export default {
    directives: { mask },
    components: { LogoColor, Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            authentication: {
                document: ''
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.authentication.document != '';
        }
    },
    methods: {
        onCancel() { },
        resetPassword(event) {
            event.preventDefault();
            this.isLoading = true;

            axios.post(this.url_api + "/auth/forgotMyPassword", this.authentication)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Sua solicitação foi realizada com sucesso! As instruções para redefinição de senha foram enviadas para o e-mail vinculado ao documento informado.",
                        type: 'success',
                        duration: 6000
                    });

                    this.$router.push('/login');
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 429) {
                        this.$notify({
                            title: "Falha",
                            text: "Você fez muitas solicitações em um curto intervalo de tempo. Aguarde alguns minutos e tente novamente.",
                            type: 'error',
                            duration: 6000
                        });
                    }
                    else if (error.status >= 500) {
                        this.$notify({
                            title: "Falha",
                            text: "Sistema indisponível! Tente novamente mais tarde.",
                            type: 'error'
                        });
                    }

                });
        }
    },
    mounted() {

        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API

    }
}
</script>

<style>
* {
    scrollbar-width: none;
}

.bottom-footer {
    margin-top: 5%;
    margin-bottom: 400px;
}
</style>